import { isIOSApp } from "./common";

// const signUpBold = `<b>Sign up</b>`
const boldedElements = [
  `<b>Sign up</b>`,
  `<b>Log in</b>`,
  `<b>Edit</b>`,
  `<b>Your Watchlists</b>`,
  `<b>Add a Category</b>`,
  `<b>Add a Channel</b>`,
  `<b>save</b>`,
  `<b>My Articles</b>`,
  `<b>Create new article</b>`,
  `<b>Untitled</b>`,
  `<b>save</b>`,
  `<b>publish</b>`,
  `<b>delete</b>`,
  `<b>preview</b>`,
  `<b>#papertrades</b>`,
  `<b>Private Message</b>`,
  `<b>Send a Direct Message</b>`,
  `<b>Invite to Private Channel</b>`,
  `<b>Find / Start a channel</b>`,
  `<b>Go</b>`,
];

const gettingStartedArray = [
  {
    id: 1,
    title: "Signing up for CEO.CA",
    content: `
      On the CEO.CA homepage, right at the top right corner, you'll find the Sign Up button, conveniently located below the Log In. Just type in your email, and we'll send you a link to log in. To fully experience what CEO.CA has to offer, your account needs to be verified. This is a breeze with our new options: verify for free using your cell phone
      ${!isIOSApp ? ', or choose a CEO PRO membership for added benefits. Alternatively, a one-time $15 fee can also get you verified instantly' : ''}. Join us and start exploring the world of CEO.CA today!
      <br/>
      <br/>
      Here's how to get started:
      <ul>
        <li><b>Sign Up:</b> Click <b>Sign Up</b> and enter your email, a username and password for your new account. Usernames cannot be changed so make it a good one!</li>
        <li><b>Verify Email:</b> Check your inbox for a verification email and follow the instructions to confirm your email address.</li>
        <li><b>Account Verification:</b> To fully unlock CEO.CA's features, verify your account. It's simple and free with your cell phone.
        ${!isIOSApp ? 'Alternatively, subscribe to CEO PRO for additional perks, or pay a one-time $15 fee for <b>instant verification.</b>': ''}
        </li>
      </ul>
      Even without verification, you can still browse CEO.CA, but chatting and accessing the Research Portals are exclusive to verified members. 
    `,
  },
  {
    id: 2,
    title: "Accessing the company channels",
    content:`
      To access a company's channel, use the <b>Search Bar</b> and enter either the <b>Company Name</b> or its <b>Ticker Symbol</b>. A link to the company channel will appear in the dropdown.
      <br/>
      <br/>
      Alternatively, you can access the channel directly by navigating to ceo.ca/(ticker name). For more information on company panels, check out our guide.
    `,
  },
  {
    id: 3,
    title: "Building a new watchlist",
    content: `
      Here's what you need to do to create a new watchlist:
      <ol>
        <li>Navigate to the Watchlist tab at the top of the homepage.</li>
        <li>Click <b>Edit</b> next to <b>Your Watchlists</b>.</li>
        <li>Click <b>Add a Category</b> and name your watchlist.</li>
        <li>To add stocks, click <b>Add a Channel</b> and enter the stock's ticker or name.</li>
        <li>Repeat for each additional stock.</li>
        <li>Click <b>Save</b> at the top of the screen to save your changes.</li>
      </ol>
    `,
  },
  {
    id: 4,
    title: "How do I submit an article?",
    content: `
      To submit an article, follow these steps:
      <ol>
        <li>Click <b>My Articles</b> in the top right corner of the right menu bar.</li>
        <li>Click <b>Create new article</b>.</li>
        <li>Enter a title at the top, where it says <b>Untitled</b>.</li>
        <li>Start writing your article below the title</li>
        <li>Use the CEO.CA article writing program's built-in features to add photos, videos, charts, links, and design elements to your article.</li>
        <li>When you're finished, save, publish, delete, or preview your article using the buttons on the bottom right.</li>
      </ol>
    `,
  },
  {
    id: 5,
    title: "What are Paper Trades?",
    content: `Paper trades are virtual BUY and SELL calls that will appear in your profile and in the ${boldedElements[14]} channel.  While the trade is open, whether long or short, your current profit or loss on the trade will show in your profile.  Once you close the trade it will remain as a historical record of your calls. You can read more about paper trades in our helpful guide below!`,
  },
  {
    id: 6,
    title: "How do I private message someone?",
    content: `Click on another user’s name or type their username in the search bar, and their profile will pop up. On the left-hand side there will be a button that says, ${boldedElements[15]}. You can then click either ${boldedElements[16]}, or ${boldedElements[17]}. The Direct Message button creates a one-on-one chat, and the Private Channel feature creates a chat where multiple users can be added.`,
  },
  {
    id: 7,
    title: "How do I create a channel?",
    content: `On the top right of your screen directly below the search bar there is a button labelled ${boldedElements[18]}. Clicking this button will give you three options. The first is to navigate to a public channel; simply type in the name of the channel and click ${boldedElements[19]}. If no channel with that name exists, you will be brought to an empty channel, where you can post publicly. The second option is to create a panel – this is publicly visible, but you must be invited in order to post. The third option is to create a private channel, which is hidden and only accessible via invite. Private channels can also be created by clicking on a user’s profile.`,
  },
  {
    id: 8,
    title: "Coloured dots next to your username",
    content:
      "These colors are assigned upon each login per device and are to distinguish between users in the flow of conversation. They cannot be selected or customized by the user.",
  },
];

export default gettingStartedArray;
